import { isSameOrigin } from './transport/transports/browser-apis';

/* eslint-disable no-console */

/**
 * Attaches a given bridge API instance to the {@link window.top}.
 *
 * @description In same-origin contexts, the bridge API should be accessed from the {@link window.top}
 * since the JavaScript context is shared. We are unable to directly access properties on {@link window.top}
 * without seeking into {@link window.top} when inside of an `iframe`. Hence, we first mount the bridge API
 * onto the window using {@link mountAPI}, and then read it off {@link window.top} using {@link readAPI}.
 *
 * @param bridgeAPI instance to attach
 */
export var mountAPI = function mountAPI(bridgeAPI) {
  try {
    // do not mount unless we are the topmost window
    if (!isSameOrigin(window)) {
      return;
    }

    // do not override if already existing on topmost window
    if (window.top.__rovoContentBridgeAPI__) {
      return;
    }
    window.top.__rovoContentBridgeAPI__ = bridgeAPI;
    window.top.__rovoBridgeDebuggerStart__ = function () {
      import('./debug/index').then(function () {
        var _window$top;
        return (_window$top = window.top) === null || _window$top === void 0 ? void 0 : _window$top.__rovoBridgeDebugger__.enable();
      }).catch(function (err) {
        return console.error('failed to initialise rovo debug API', err);
      });
    };
  } catch (_unused) {
    // bail out if any errors take place (browser quirks on accessing window.top from a cross-origin frame)
    return;
  }
};

/**
 * Reads a given bridge API instance off {@link window.top} if the JavaScript context is shared.
 * @returns null if bridge API is not present OR JS context is not shared with top window; otherwise
 * yields the bridge API instance on {@link window.top}.
 */
export var readAPI = function readAPI() {
  try {
    if (isSameOrigin(window)) {
      return window.top.__rovoContentBridgeAPI__;
    } else {
      return null;
    }
  } catch (_unused2) {
    return null;
  }
};

/**
 * Clears shared reference to bridge API for GC purposes.
 */
export var clearAPI = function clearAPI() {
  try {
    if (isSameOrigin(window)) {
      window.top.__rovoContentBridgeAPI__ = undefined;
    }
  } catch (_unused3) {
    return;
  }
};